const rules = {
  'isValidPhoneNumber': {
    getMessage: field => {
      return `${field} number is invalid`
    },
    validate: (phoneNumber, [valid]) => {
      return valid === 'true'
    }
  }
}

const dictionary = {
  en: {
    messages: {
      required: (field) => field + ' is required',
      email: (field) => field + ' is invalid'
    }
  }
}

export default (Validator) => {
  Validator.localize(dictionary)
  Object.keys(rules).forEach(rule => {
    Validator.extend(rule, rules[rule])
  })
}



// WEBPACK FOOTER //
// ./src/model/validatorRules.js